module.exports = __webpack_public_path__ + "img/basic-info.79ebbed6.svg";